import { format } from 'date-fns';
import { ColumnFilter } from '../Common/ColumnFilter';
export const COLUMNS = [
    {
        Header: 'S.No.',
        Footer: 'Item Category Code',
        accessor: 'id',
        Filter: ColumnFilter,
        disableFilters: true,
    },
    {
        Header: 'Item Group Name',
        Footer: 'Item Group Name',
        accessor: 'gm_group_name',
        Filter: ColumnFilter,
        disableFilters: true,
    },
    {
        Header: 'Item Category Name',
        Footer: 'Item Category Name',
        accessor: 'cm_category_name',
        Filter: ColumnFilter,
        disableFilters: true,
    },
    {
        Header: 'No.Of.Items',
        Footer: 'No.Of.Items',
        accessor: 'item_count',
        Filter: ColumnFilter,
        disableFilters: true,
    },
    {
        Header: 'Status',
        Footer: 'Item Category Status',
        accessor: 'status',
        Filter: ColumnFilter,
        disableFilters: true,
    }
]

export const GROUPED_COLUMNS = [
]